export default "__VITE_ASSET__B2h9H4MA__"